const horizontalMenuConfig = [

]

export default horizontalMenuConfig
